package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UScreenFlowModel(
    @SerialName("flow") val flow: String,
    @SerialName("version") val version: String,
    @SerialName("groups") val groups: List<UScreenGroup>,
) {
    companion object {
        val preview = UScreenFlowModel(
            flow = "onboarding",
            version = "1.0",
            groups = listOf(
                UScreenGroup.preview,
                UScreenGroup(
                    label = "Profile",
                    color = "#4A90D9",
                    screens = listOf(
                        UScreen(
                            id = "name",
                            blocks = listOf(
                                LabelBlock.preview,
                                SpacerBlock(height = 16),
                                TextInputBlock.preview,
                            ),
                            cta = UScreenCta.preview,
                        ),
                    ),
                ),
            ),
        )
    }
}
